// Models
import { CompanyToEditDto } from '../models/company-to-edit-dto.model';
import { CompanyListModel } from '../models/company-view-model.model';

export namespace CompanyActions {
	export class GetAll {
		static readonly type = '[Company] Get Companies';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Company] Set Companies';
		constructor(public companies: CompanyListModel[]) {}
	}

	export class Create {
		static readonly type = '[Company] Create Company';
		constructor(public data: { company: CompanyToEditDto; showSpinner?: boolean; showToast?: boolean } = { company: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateSuccess {
		static readonly type = '[Company] Create Company Success';
		constructor(public company: CompanyListModel) {}
	}

	export class CreateError {
		static readonly type = '[Company] Create Company Error';
	}

	export class Update {
		static readonly type = '[Company] Update Company';
		constructor(public data: { company: CompanyToEditDto; showSpinner?: boolean; showToast?: boolean } = { company: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[Company] Update Company Success';
		constructor(public company: CompanyListModel) {}
	}

	export class UpdateError {
		static readonly type = '[Company] Update Company Error';
	}
}
